import { Tab, Tabs } from '@mui/material'
import Stack from '@mui/material/Stack'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { WorkInstructionUIStore } from '../../stores/work-instruction.ui-store'

interface Props {
  store: WorkInstructionUIStore
}

export const WorkInstructionTabs = observer(({ store }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Stack paddingX={theme.customSpacing.m}>
      <Tabs value={store.selectedTabType} onChange={(_, value) => store.setSelectedTabType(value)}>
        <Tab label={t('vessel', 'Vessel')} value='vessel' data-cy='wi-tab-vessel' />
        <Tab label={t('truck', 'Truck')} value='truck' data-cy='wi-tab-truck' />
        <Tab label={t('train', 'Train')} value='train' data-cy='wi-tab-train' />
        <Tab
          label={t('internalMoves', 'Internal moves')}
          value='internal'
          data-cy='wi-tab-internal'
        />
      </Tabs>
    </Stack>
  )
})
